import React, { useEffect, useState } from "react";
import CommuBrdCmntRegApi from "Apis/CommuBrdCmntRegApi";


const CommuCmntWriteUi = ({ brdCd, brdPstdSno }: any) => {
    const CmntReg = async (cmntCtxt: string, cptchTkn: string) => {
        CommuBrdCmntRegApi(brdCd, brdPstdSno, cmntCtxt, cptchTkn).then((resp) => {

        })    
    };
        

    return (
        <>
            <div>
                <textarea name="" id=""></textarea>
                <button onClick={() => CmntReg("댓글 내용", "captchaToken")}>
                    댓글 등록
                </button>
            </div>
        </>
    );
};

export default CommuCmntWriteUi;